import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import bannerTemplateList from '../../components/_banner_template_list';

const view = '[data-view="stock"]';
const init = () => {
    createAppWrap({
        el: view,
        data() {
            return {};
        },
        components: {
            // バナーテンプレートリスト
            'banner-template-list': bannerTemplateList,
        },
        mixins: [commonMixin, flashMessageMixin],
        mounted: function() {
            this.$refs.bannerTemplateList.getTemplateList();
        },
    });
};

if (document.querySelector(view)) {
    init();
}
